import { GridCellKind, type CustomCell, type CustomRenderer } from '@glideapps/glide-data-grid'

import { ColumnTypes } from '@makyoapp/makyo-sdk/models/Table'

import { generateBarcodeURL, IBarcodeCell } from '@/core/models/columns/barcode'

import { drawImage } from '../helpers/draw-image'

export interface CustomBarcodeCellProps {
  readonly type: ColumnTypes
  readonly cell: IBarcodeCell
  readonly extra: Record<string, unknown>
}

export type CustomBarcodeCell = CustomCell<CustomBarcodeCellProps>

const CustomBarcodeRenderer: CustomRenderer<CustomBarcodeCell> = {
  kind: GridCellKind.Custom,
  isMatch: (cell: CustomCell): cell is CustomBarcodeCell =>
    (cell.data as CustomBarcodeCellProps).type === ColumnTypes.Barcode,
  needsHover: false,
  needsHoverPosition: false,
  measure: (_ctx, cell) => cell.data.cell.toString()?.length * 50,

  draw: (args, cell) => {
    const barcodeCell = cell.data.cell
    const barcodeValue = barcodeCell.value
    const barcodeOptions = barcodeCell.barcodeOptions

    if (barcodeValue) {
      const dataURL = generateBarcodeURL(barcodeValue as any, barcodeOptions)
      drawImage(args, dataURL, 0, args.cell.contentAlign)
    }

    return true
  },
  onClick: (args) => {
    const cell = args.cell as CustomBarcodeCell
    const dataURL = cell.data.cell.toString()

    if (dataURL) {
      // see `GridPreviewModal.tsx` for more details
      const barCodeClickEvent = new CustomEvent('preview-modal-open', {
        detail: { title: 'Barcode Preview', value: dataURL, width: 350 },
      })
      document.dispatchEvent(barCodeClickEvent)
    }

    return undefined
  },
}

export default CustomBarcodeRenderer
